module.exports = "mat-grid-tile {\n    background: lightblue;\n}"


//////////////////
// WEBPACK FOOTER
// ./public/app/modules/home/home.component.css
// module id = ./public/app/modules/home/home.component.css
// module chunks = main